import { render, staticRenderFns } from "./WrapGloveSize.vue?vue&type=template&id=53fa4c19&"
import script from "./WrapGloveSize.vue?vue&type=script&lang=ts&"
export * from "./WrapGloveSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports